import PropTypes from 'prop-types';
import {MEDIUM} from '../../helpers/IconSize';
import './DestinationMessage.less';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {emitUrgencyDestinationMessageEvent} from '../../helpers/edap';
import BaseUrgencyMessage from '../../BaseUrgencyMessage/BaseUrgencyMessage';
const BASE_CLASS = 'UrgencyDestinationMessage';

export default class DestinationMessageComponent extends BaseUrgencyMessage {
    static contextType = TrackingContext;
    static propTypes = {
        /** Optional classname to override the root styling */
        className: PropTypes.string,
        /** Sets size and behavior of font and icon */
        size: PropTypes.string,
        /** Data to use in rendering component */
        destinationMessage: PropTypes.oneOfType([
            PropTypes.shape({
                iconTitleText: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            }),
            PropTypes.shape({
                iconTitleTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            }),
            PropTypes.shape({
                iconTitleTextV3: PropTypes.shape({
                    icon: PropTypes.string,
                    title: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            }),
            PropTypes.shape({
                iconTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            }),
            PropTypes.shape({
                iconText: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string,
                    messageValueType: PropTypes.string,
                    link: PropTypes.shape({
                        linkText: PropTypes.string,
                        linkHref: PropTypes.string
                    })
                })
            })
        ]),
        /** If true, changes small greyscale icon to its color variant */
        color: PropTypes.bool,
        /** Set to true in order to hide the component from screen readers */
        ariaHidden: PropTypes.bool
    };

    static defaultProps = {
        className: '',
        size: MEDIUM,
        destinationMessage: {},
        color: false,
        ariaHidden: false
    };

    // eslint-disable-next-line complexity
    static getDestinationMessageContent(destinationMessage) {
        if (destinationMessage) {
            const {iconText, iconTextV1, iconTitleText, iconTitleTextV1, iconTitleTextV3} = destinationMessage;
            return iconText || iconTextV1 || iconTitleText || iconTitleTextV1 || iconTitleTextV3 || {};
        }
        return {};
    }

    componentDidMount() {
        const {messageValueType} = DestinationMessageComponent.getDestinationMessageContent(this.props.destinationMessage);
        if (messageValueType) {
            emitUrgencyDestinationMessageEvent(this.context, messageValueType);
        }
    }

    render() {
        const urgencyMessageContent = DestinationMessageComponent.getDestinationMessageContent(this.props.destinationMessage);
        const baseClass = BASE_CLASS;
        return this.generateComponent({baseClass, ...this.props}, urgencyMessageContent);
    }

}
